export class FinancesRoutingRouteNames {
    public static readonly PaymentOutlet = 'finances-payment-outlet';
    public static readonly PaymentProcessRoutes = {
        PaymentSourceSelection: 'payment-source-selection',
        PaymentSummary: 'payment-summary',
        PaymentPayRequest: 'payment-pay-request',
        Success: 'success',
    };
}
